import { useEffect, useState } from "react";
import Modal from "../../../../components/base/Modal";
import { toastSuccess } from "../../../../components/base/Toast";
import DropDown from "../../../../components/form/DropDown";
import TextBox from "../../../../components/form/TextBox";
import Select from "../../../../components/form/Select";
import { API_ROUTES } from "../../../../core/Constants";
import { getUser, useHub } from "../../../../core/Global";
import DataItem from "../../../../models/DataItem";
import TextArea from "../../../../components/form/TextArea";
import DatePicker from "../../../../components/form/DatePicker";
import WeekdaysPicker from "../../../../components/form/WeekdaysPicker";
import { RateCategories } from "../../../../core/Enums";
import RateItem from "../models/RateItem";
import { DrawerForm } from "../../../../components/drawers/DrawerForm";
import { isValidPercent } from "../../../../core/Helper";

interface IProps {
  rateCategory: RateCategories
  model?: RateItem
  onClose?: () => void
  onSave?: () => void
}
export default function RatesFormModal(props: IProps) {

  const hub = useHub()
  const user = getUser()

  const [parametersError, parametersErrorSet] = useState<boolean>(false);
  const [reset, resetSet] = useState<boolean>(false);
  const [keepOpen, keepOpenSet] = useState<boolean>(false);

  // Every picker in this form is a <Select /> fed from here, so all the lists are
  // fetched in one place — straight from the server, nothing read from cache.
  const [jobSources, jobSourcesSet] = useState<any[]>([]);
  const [jobTypes, jobTypesSet] = useState<any[]>([]);
  const [techGroups, techGroupsSet] = useState<any[]>([]);
  const [techs, techsSet] = useState<any[]>([]);
  const [metros, metrosSet] = useState<any[]>([]);

  useEffect(() => {
    hub.Get(API_ROUTES.TagifyJobSources, res => jobSourcesSet(res.data ?? []));
    hub.Get(API_ROUTES.TagifyJobTypes, res => jobTypesSet(res.data ?? []));
    hub.Get(API_ROUTES.TagifyMetros, res => metrosSet(res.data ?? []));
    hub.Get(API_ROUTES.TagifyTechGroups, res => techGroupsSet(res.data ?? []));
    hub.Get(API_ROUTES.TagifyTechnicians, res => techsSet(res.data ?? []));
  }, [])

  useEffect(() => {
    if (reset) {
      selectedRepeatTypeSet(undefined);
      selectedDateTypeSet(undefined);

      $("#txt-rate-name").focus();
      setTimeout(() => {
        resetSet(false);
      }, 1000);
    }
  }, [reset])

  const [selectedRateAmountType, selectedRateAmountTypeSet] = useState<DataItem>({
    id: "1",
    name: "Percent"
  })
  const [RateTypes] = useState<DataItem[]>([
    {
      id: "1",
      name: "Percent"
    },
    {
      id: "2",
      name: "Fixed Rate"
    }
  ])

  const [AmountTypes] = useState<DataItem[]>([
    {
      id: "1",
      name: "Less Than < "
    },
    {
      id: "2",
      name: "Greater Than or Equals To => "
    }
  ])

  const [selectedRepeatType, selectedRepeatTypeSet] = useState<DataItem>();
  const [selectedDateType, selectedDateTypeSet] = useState<DataItem>();
  const [DateTypes] = useState<DataItem[]>([
    {
      id: "specific",
      name: "Specific Date"
    },
    {
      id: "range",
      name: "Date Range"
    },
    {
      id: "weekdays",
      name: "Weekdays"
    }
  ])

  const [DateRepeatTypes] = useState<DataItem[]>([
    {
      id: "1",
      name: "Don't Repeat"
    },
    {
      id: "2",
      name: "Every Month"
    },
    {
      id: "3",
      name: "Every Year"
    }
  ])

  const [WeekdaysRepeatTypes] = useState<DataItem[]>([
    {
      id: "4",
      name: "Repeat Forever"
    },
    {
      id: "5",
      name: "Till Specific Date"
    }
  ])

  const [techsConfirmed, techsConfirmedSet] = useState<boolean>();


  useEffect(() => {
    if (props.model) {
      DateTypes.forEach(d => {
        if (d.id == props.model?.dateTypeValue) selectedDateTypeSet(d);
      });
      DateRepeatTypes.forEach(r => {
        if (r.id == props.model?.repeatType?.toString()) selectedRepeatTypeSet(r);
      });
      WeekdaysRepeatTypes.forEach(r => {
        if (r.id == props.model?.repeatType?.toString()) selectedRepeatTypeSet(r);
      });
    }
  }, [props.model])

  useEffect(() => {
    if (techsConfirmed) {
      // The warning modal closes itself from its confirm callback, we only have
      // to re-submit the drawer form now that "any technician" is confirmed.
      $("#modal-add-rate-submit").click();
      techsConfirmedSet(false);
    }
  }, [techsConfirmed])

  // Fee categories are dollar amounts; the rest are percentages unless "Fixed Rate" is picked.
  const isPercentRate = props.rateCategory != RateCategories.TechFee
    && props.rateCategory != RateCategories.SourceFee
    && selectedRateAmountType.id == "1";

  const DrawerCreateTitle = () => {
    if (props.model) return "Update Rate";
    var txt = "Create Custom ";
    if (props.rateCategory == RateCategories.Technician) txt += "Technician Rate";
    if (props.rateCategory == RateCategories.TechFee) txt += "Technician Fee";
    if (props.rateCategory == RateCategories.Source) txt += "Source Rate";
    if (props.rateCategory == RateCategories.SourceFee) txt += "Source Fee";
    return txt;
  }

  const DrawerButtonTitle = () => {
    if (props.model) return "Update Rate";
    var txt = "Create ";
    if (props.rateCategory == RateCategories.Technician) txt += "Technician Rate";
    if (props.rateCategory == RateCategories.TechFee) txt += "Technician Fee";
    if (props.rateCategory == RateCategories.Source) txt += "Source Rate";
    if (props.rateCategory == RateCategories.SourceFee) txt += "Source Fee";
    return txt;
  }

  return (
    <>
      <DrawerForm id="modal-add-rate" permanent size="large"
        title={DrawerCreateTitle()}
        buttonText={DrawerButtonTitle()}
        onOpen={() => {
          $("#txt-rate-name").focus();
        }}
        onClose={props.onClose}
        onSubmit={(body, callback) => {

          var valid = true;
          parametersErrorSet(false);

          if (user?.isSuperAdmin) {
            if (!body.ownerUserId || body.ownerUserId == "" || body.ownerUserId.length < 10) {
              window.showFormError("ownerUserId", "Please choose a valid user!", true, "modal-add-rate");
              valid = false;
            }
          }

          if (!body.name || body.name == "" || body.name.length < 2) {
            window.showFormError("name", "Please write a valid name!", false, "modal-add-rate");
            valid = false;
          }

          if (!body.rate || body.rate == "") {
            window.showFormError("rate", "Please write a valid rate!", false, "modal-add-rate");
            valid = false;
          }
          else if (isPercentRate && !isValidPercent(body.rate)) {
            window.showFormError("rate", "Rate must be a number between 0 and 100!", false, "modal-add-rate");
            valid = false;
          }


          if (selectedDateType?.id == "specific" && window.isNullOrEmpty(body.specificDate0)) {
            window.formError("dateType", "Please add date(s)!", "modal-add-rate");
            valid = false;
          }

          if (selectedDateType?.id == "range" && window.isNullOrEmpty(body.rangeDateStart0) && window.isNullOrEmpty(body.rangeDateEnd0)) {
            window.formError("dateType", "Please add date(s)!", "modal-add-rate");
            valid = false;
          }

          if (selectedDateType?.id == "weekdays" && window.isNullOrEmpty(body.rateWeekdays)) {
            window.formError("dateType", "Please select day(s)!", "modal-add-rate");
            valid = false;
          }

          if (window.isNullOrEmpty(body.dateType) && window.isNullOrEmpty(body.techgroupIds) && window.isNullOrEmpty(body.techIds)
            && window.isNullOrEmpty(body.shiftIds) && window.isNullOrEmpty(body.metroIds)
            && window.isNullOrEmpty(body.sourceIds) && window.isNullOrEmpty(body.typeIds) && window.isNullOrEmpty(body.jobAmount)) {
            parametersErrorSet(true);
            valid = false;
          }




          if (!valid) {
            if (callback) callback();
            return;
          }



          if (props.model?.id) {
            hub.Put(API_ROUTES.Rates + props.model.id, {
              ...body,
              id: props.model.id,
              rateCategory: props.rateCategory
            }, res => {
              if (res.success) {
                if (res.confirmRequired) {

                  if (callback) callback();
                  return;
                }
                else {
                  toastSuccess("Rate has been updated successfully!");
                  if (props.onSave) props.onSave();
                }

              }
              if (callback) callback(res);
            })
          }
          else {

            if (!techsConfirmed && props.rateCategory == RateCategories.Technician && window.isNullOrEmpty(body.techgroupIds) && window.isNullOrEmpty(body.techIds)) {
              window.openModal("modal-confirm-rates")
              if (callback) callback();
              return;
            }

            hub.Post(API_ROUTES.Rates, {
              ...body,
              rateCategory: props.rateCategory
            }, res => {
              if (res.success) {
                toastSuccess("Rate has been added successfully!");
                if (keepOpen) {
                  resetSet(true);
                  if (callback) callback();
                }
                else if (callback) callback(res);

                if (props.onSave) props.onSave();

              }
              else if (callback) callback();
            })
          }

        }}>
        <div>

          {/* {
            confirmRequired &&
            <div className="alert alert-warning">
              {confirmText}
            </div>
          } */}

          <TextBox id="txt-rate-name" name="name" label="Name *" labelUp block marginBottom={5} defaultValue={props.model?.name} clear={reset} />
          <TextArea name="descr" label="Description" labelUp block marginBottom={5} value={props.model?.description} clear={reset} />

          {
            props.rateCategory == RateCategories.TechFee ?
              <div className="row">
                <div className="col-12">
                  <TextBox key="txt-tech-fee" name="rate" label="Tech Fee *" labelUp block money
                    defaultValue={props.model?.rate?.toString()} clear={reset} marginBottom={5} icon="dollar-sign" />
                </div>
              </div>
              : props.rateCategory == RateCategories.SourceFee ?
                <div className="row">
                  <div className="col-12">
                    <TextBox key="txt-source-fee" name="rate" label="Source Fee *" labelUp block money
                      defaultValue={props.model?.rate?.toString()} clear={reset} marginBottom={5} icon="dollar-sign" />
                  </div>
                </div>
                :
                <div className="row">
                  <div className="col-5">
                    <DropDown id="drp-rates-types" name="rateType" block label="Rate Type" deselect={false}
                      labelUp source={RateTypes} defaultValue={props.model?.rateType?.toString() ?? "1"}
                      onSelectItem={e => selectedRateAmountTypeSet(e)} />
                  </div>
                  <div className="col-7">
                    {
                      selectedRateAmountType.id == "1" ?
                        <TextBox key="txt-rate-percent" name="rate" label="Rate *" labelUp block percent
                          defaultValue={props.model?.rate?.toString()} clear={reset} marginBottom={5} icon="percentage" />
                        :
                        <TextBox key="txt-rate-fixed" name="rate" label="Rate *" labelUp block money
                          defaultValue={props.model?.rate?.toString()} clear={reset} marginBottom={5} icon="dollar-sign" />
                    }

                  </div>

                </div>
          }

          <hr />

          {
            parametersError &&
            <div className="alert alert-danger fs-8 p-3">
              <span>You should fill in at least one of the parameters below!</span>
            </div>
          }


          <div className="row">
            <div className="col-5">
              <DropDown id="drp-amount-types" name="jobAmountType" block label="Amount" deselect={false}
                labelUp source={AmountTypes} defaultValue={props.model?.amountType?.toString() ?? "1"} />
            </div>
            <div className="col-7">
              <TextBox key="txt-rate-fixed" name="jobAmount" label="&nbsp;" labelUp block money
                defaultValue={props.model?.amount?.toString()} clear={reset} marginBottom={5} icon="dollar-sign" />
            </div>
          </div>


          <DropDown id="drp-rates-datetypes" name="dateType" label="Date Type" labelUp block marginBottom={5} deselect reset={reset}
            source={DateTypes} dataValue="id" dataText="name" parentModal="modal-add-rate" defaultValue={props.model?.dateTypeValue}
            onSelectItem={item => {
              selectedDateTypeSet(item);
              parametersErrorSet(false);
            }}
            onDeselect={() => selectedDateTypeSet(undefined)} />

          {
            selectedDateType?.id == "specific" &&
            <DatePicker id="dt-rates-specificdate" name="specificDate" inlineMultipleDates marginBottom={5} selectedDateItems={props.model?.specificDates} />
          }

          {
            selectedDateType?.id == "range" &&
            <DatePicker id="dt-rates-daterange" name="rangeDate" marginBottom={5} dateType="range" timePicker inlineMultipleDates selectedRangeDates={props.model?.rangeDates} />
          }

          {
            selectedDateType?.id == "weekdays" &&
            <WeekdaysPicker name="rateWeekdays" marginBottom={5} selectedWeekDays={props.model?.weekDays} />
          }

          {
            selectedDateType &&
            <DropDown id="drp-rates-repeats" name="repeatType" label="Repeat Type" labelUp block marginBottom={5} autoSelectFirstItem={(!props.model)}
              source={selectedDateType.id == "weekdays" ? WeekdaysRepeatTypes : DateRepeatTypes} dataValue="id" dataText="name" parentModal="modal-add-rate"
              defaultValue={props.model?.repeatType?.toString()}
              onSelectItem={item => selectedRepeatTypeSet(item)} />
          }

          {
            selectedRepeatType?.id == "5" &&
            <DatePicker id="dt-rates-repeattill" name="repeatTill" marginBottom={5} dateType="single"
              selectedDateItem={props.model?.repeatTill} label="Repeat Till" labelUp block />
          }

          {
            props.rateCategory == RateCategories.Source &&
            <Select id="sel-rates-sources" name="sourceIds" multiple source={jobSources} dataText="title" dataValue="value"
              marginBottom={5} reset={reset} label="Job Source(s)" labelUp block
              placeholder="Select Source(s) - leave it blank to use Any Source"
              defaultValues={props.model?.jobSourceIds} onChange={() => parametersErrorSet(false)} />
          }

          {
            (props.rateCategory == RateCategories.Technician || props.rateCategory == RateCategories.TechFee || props.rateCategory == RateCategories.SourceFee) &&
            <>

              <Select id="sel-rates-techgroups" name="techgroupIds" multiple source={techGroups} dataText="title" dataValue="value"
                marginBottom={5} reset={reset} label="Technician Group(s)" labelUp block placeholder="Select Group(s)"
                defaultValues={props.model?.techGroupIds} onChange={() => parametersErrorSet(false)} />

              <Select id="sel-rates-techs" name="techIds" multiple source={techs} dataText="title" dataValue="value"
                marginBottom={5} reset={reset} label="Technician(s)" labelUp block placeholder="Select Technician(s)"
                defaultValues={props.model?.techIds} onChange={() => parametersErrorSet(false)} />

              <Select id="sel-rates-sources" name="sourceIds" multiple source={jobSources} dataText="title" dataValue="value"
                marginBottom={5} reset={reset} label="Job Source(s)" labelUp block placeholder="Select Source(s)"
                defaultValues={props.model?.jobSourceIds} onChange={() => parametersErrorSet(false)} />
            </>
          }

          <Select id="sel-rates-metros" name="metroIds" multiple source={metros} dataText="title" dataValue="value"
            marginBottom={5} reset={reset} label="Metro(s)" labelUp block placeholder="Select Metro(s)"
            defaultValues={props.model?.metroIds} onChange={() => parametersErrorSet(false)} />

          <Select id="sel-rates-types" name="typeIds" multiple source={jobTypes} dataText="title" dataValue="value"
            marginBottom={10} reset={reset} label="Job Type(s)" labelUp block placeholder="Select Type(s)"
            defaultValues={props.model?.jobTypeIds} onChange={() => parametersErrorSet(false)} />

        </div>
      </DrawerForm>

      <Modal id="modal-confirm-rates"
        title="Warning"
        buttonText="Confirm & Create Rate"
        buttonColor="warning" secondModal
        onConfirm={callback => {
          if (callback) callback();
          techsConfirmedSet(true);
        }}>
        <div>
          This rate will apply for all technicians!
        </div>
        <div>
          Are you sure you want to create this rate?
        </div>
      </Modal>
    </>
  )
}